/* Bella 1 éves szülinapi akció (2026. október) – viselkedés. Markup: snippets/bcb-bday.liquid, stílus: assets/bcb-bday.css.
   - [data-bday]: az akció elemei; a záráskor (okt. 31. 24:00, Budapest) a gyorsítótárazott oldalakon is eltűnnek
   - [data-bday-d|h|m], [data-bday-left]: visszaszámláló (data-lang="hu|en")
   - [data-bday-copy]: a BDAY kód vágólapra másolása
   - #bcb-bdp: pop-up, látogatónként egyszer (localStorage), 5 mp oldalon töltött idő után (sessionStorage-ben számolva,
     így oldalváltáskor sem indul újra). Teszt: ?bday=1 (mindig megjelenik). */
(function(){
  if (window.__bcbBday) return; window.__bcbBday = 1;
  var START = Date.parse('2026-10-01T00:00:00+02:00'), END = Date.parse('2026-11-01T00:00:00+01:00');
  var SEEN = 'bcb_bday26_seen', T0 = 'bcb_bday26_t0', DELAY = 5000;
  var force = /[?&]bday=1\b/.test(location.search);
  function ls(k, v){ try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch(e){ return null; } }
  function ss(k, v){ try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch(e){ return null; } }
  function track(name, data){
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch(e){}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch(e){}
  }
  function live(){ var n = Date.now(); return (n >= START && n < END) || force; }

  function leftText(lang, ms){
    var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5);
    if (lang === 'en') return d >= 7 ? d + ' days left' : d >= 2 ? 'Only ' + d + ' days left!' : d === 1 ? 'Last 2 days!' : h >= 1 ? 'Last day! Ends at midnight' : 'Ends tonight!';
    return d >= 7 ? 'Még ' + d + ' napig' : d >= 2 ? 'Már csak ' + d + ' nap!' : d === 1 ? 'Utolsó 2 nap!' : h >= 1 ? 'Utolsó nap! Éjfélig' : 'Ma éjfélig!';
  }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var ms = Math.max(0, END - Date.now());
    document.querySelectorAll('[data-bday-d]').forEach(function(el){ el.textContent = Math.floor(ms / 864e5); });
    document.querySelectorAll('[data-bday-h]').forEach(function(el){ el.textContent = pad(Math.floor(ms / 36e5) % 24); });
    document.querySelectorAll('[data-bday-m]').forEach(function(el){ el.textContent = pad(Math.floor(ms / 6e4) % 60); });
    document.querySelectorAll('[data-bday-left]').forEach(function(el){ el.textContent = leftText(el.getAttribute('data-lang'), ms); });
  }

  function copy(btn){
    var code = btn.getAttribute('data-bday-copy') || 'BDAY', ok = btn.getAttribute('data-ok') || 'Másolva ✓', orig = btn.getAttribute('data-orig') || btn.textContent;
    btn.setAttribute('data-orig', orig);
    function done(){ btn.textContent = ok; btn.classList.add('is-ok'); setTimeout(function(){ btn.textContent = orig; btn.classList.remove('is-ok'); }, 2200); }
    function fallback(){ var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0;top:0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch(e){} t.remove(); done(); }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    track('bcb_bday_copy', { place: btn.getAttribute('data-place') || '' });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-bday-copy]');
    if (b){ e.preventDefault(); copy(b); }
  });

  /* ── pop-up ── */
  var pop, lastFocus;
  function openPop(){
    pop = document.getElementById('bcb-bdp');
    if (!pop || !pop.hidden) return;
    ls(SEEN, String(Date.now()));
    lastFocus = document.activeElement;
    pop.hidden = false; pop.classList.add('is-in');
    document.documentElement.classList.add('bcb-bdp-lock');
    var f = pop.querySelector('.bdp-box'); if (f) try { f.focus({ preventScroll: true }); } catch(e){ f.focus(); }
    track('bcb_bday_popup_view', { lang: pop.getAttribute('data-lang') });
  }
  function closePop(how){
    if (!pop || pop.hidden) return;
    track('bcb_bday_popup_close', { how: how || 'x', lang: pop.getAttribute('data-lang') });
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    pop.classList.remove('is-in'); pop.classList.add('is-out');
    setTimeout(function(){ pop.hidden = true; pop.classList.remove('is-out'); document.documentElement.classList.remove('bcb-bdp-lock'); if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch(e){} }, reduce ? 0 : 230);
  }
  function wirePop(){
    pop = document.getElementById('bcb-bdp');
    if (!pop) return;
    pop.addEventListener('click', function(e){
      if (e.target.closest('[data-bdp-close]')) { e.preventDefault(); closePop(e.target.closest('.bdp-later') ? 'later' : e.target.closest('.bdp-scrim') ? 'scrim' : 'x'); return; }
      var cta = e.target.closest('.bdp-cta');
      if (cta){
        track('bcb_bday_popup_click', { lang: pop.getAttribute('data-lang') });
        if ((cta.getAttribute('href') || '').charAt(0) === '#') { closePop('cta'); }
      }
    });
    document.addEventListener('keydown', function(e){
      if (!pop || pop.hidden) return;
      if (e.key === 'Escape') closePop('esc');
      if (e.key === 'Tab'){
        var f = pop.querySelectorAll('a[href],button:not([tabindex="-1"])'), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
    if (!force && ls(SEEN)) return;
    var t0 = parseInt(ss(T0), 10);
    if (!t0 || isNaN(t0)) { t0 = Date.now(); ss(T0, String(t0)); }
    var wait = force ? 1200 : Math.max(1500, DELAY - (Date.now() - t0));
    setTimeout(function attempt(){
      if (!live()) return;
      if (document.hidden) { document.addEventListener('visibilitychange', function v(){ if (!document.hidden){ document.removeEventListener('visibilitychange', v); setTimeout(attempt, 800); } }); return; }
      /* ha épp nyitva a kosárfiók, más modál vagy a süti-sáv, később próbáljuk (a süti-sávra legfeljebb ~20 mp-et várunk) */
      var cb = document.getElementById('shopify-pc__banner');
      if (cb && cb.offsetParent !== null && cb.getBoundingClientRect().height > 0 && (attempt.n = (attempt.n || 0) + 1) <= 5) { setTimeout(attempt, 4000); return; }
      if (document.querySelector('cart-drawer.active, .drawer.active, details-modal[open], .modal.active, #bcb-hu-lb.open, #bcb-en-lb.open')) { setTimeout(attempt, 4000); return; }
      openPop();
    }, wait);
  }

  function init(){
    if (!live()) { document.querySelectorAll('[data-bday]').forEach(function(el){ el.hidden = true; el.style.display = 'none'; }); return; }
    tick(); setInterval(tick, 30000);
    wirePop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
